<div class="modal-header">
  <h3 class="modal-title">
    <span class="title-wrapper">{{ modalTitle }}</span>
  </h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="filter-strip" [hidden]="minimise">
  <div class="filter-item">
    <label>From</label>
    <input class="form-control" type="date" [ngModel]="fromDate" (ngModelChange)="fromDate = $event; applyFilter()">
  </div>
  <div class="filter-item">
    <label>To</label>
    <input class="form-control" type="date" [ngModel]="toDate" (ngModelChange)="toDate = $event; applyFilter()">
  </div>
  <div class="search-holder">
    <i class="fa fa-search"></i>
    <input type="text" [ngModel]="searchText" (ngModelChange)="searchText = $event; applyFilter()" class="gg-global-search" name="global-search">
    <i class="fa fa-times gg-clear-search" (click)="clearSearch()"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @for (detail of filteredUndoData; track $index; let i = $index) {
<div class="gt-cell-details">
    <div class="detail-main">
      <h5>
        <b>{{ detail.display_name || detail.updated_by_name || 'User' }}</b>
        <span class="time-text">{{ getTimeAgo(detail.created_on || detail.updated_on) }}</span>
      </h5>
      <div class="detail-row">
        <div class="label">Value :</div>
        <div class="value" [ngClass]="{ first: i === 0 }"><b>{{ detail.audit_cell_data }}</b></div>
        <div class="label">Updated On :</div>
        <div class="value">{{ (detail.updated_on || '') | slice:0:10 }}</div>
      </div>
    </div>
    <div class="detail-action">
      <button type="button" class="save-button" (click)="revert(detail)">Revert</button>
    </div>
  </div>
}

  @if (!loading && filteredUndoData.length === 0) {
<div class="no-data">
    No audit cell changes available for current selection.
  </div>
}
</div>
